import { CurrencyType, GameMode, IBombPotConfig, NLH, RewardSystem, TableType } from "@soposopo/sopo-models";
// export type TableType = 'RING'|'SNG'|'MTT';
// export type LimitType = 'NL'|'PL';
type Seconds = number;

export interface CommonConfigProps {
    type: TableType;
    tableName: string;
    gameConfigId: string;
    gameMode: GameMode;
    seats: number;
    restricted: boolean;
    currency: CurrencyType;
    rewardSystem: RewardSystem;
    badbeatJackpotEligible: boolean;
}

export const INIT_COMMON_CONFIG_PROPS: CommonConfigProps = {
    type: TableType.SNG,
    tableName: '',
    gameConfigId: '',
    gameMode: NLH,
    seats: 0,
    restricted: false,
    currency: CurrencyType.GOLD,
    rewardSystem: RewardSystem.NONE,
    badbeatJackpotEligible: false,
}

export interface RingConfig extends CommonConfigProps {
    type: TableType.RING;
    blinds: string;
    minBuyIn: number;
    maxBuyIn: number;
    gpsRestriction: boolean;
    bombPotConfig: IBombPotConfig | null;
}

export const INIT_RING_CONFIG: RingConfig = {
    ...INIT_COMMON_CONFIG_PROPS,
    type: TableType.RING,
    blinds: '',
    minBuyIn: 0,
    maxBuyIn: 0,
    gpsRestriction: false,
    bombPotConfig: null,
}

export interface SngConfig extends CommonConfigProps {
    type: TableType.SNG;
    gpsRestriction: boolean;
    buyIn: number;
}

export const INIT_SNG_CONFIG: SngConfig = {
    ...INIT_COMMON_CONFIG_PROPS,
    type: TableType.SNG,
    gpsRestriction: false,
    buyIn: 0,
}

export interface MttConfig extends CommonConfigProps {
    blindsTime: number;
    startingDate: Seconds;
    buyIn: number;
}

export const INIT_MTT_CONFIG: MttConfig = {
    ...INIT_COMMON_CONFIG_PROPS,
    blindsTime: 0,
    startingDate: Date.now(),
    buyIn: 0,
}

export interface FreePlayLobbyState {
    ringConfigs: IGameConfig<RingConfig>,
    sngConfigs: IGameConfig<SngConfig>,
    mttConfigs: IGameConfig<MttConfig>,
}

export const INIT_FREE_PLAY_LOBBY_STATE: FreePlayLobbyState = {
    ringConfigs: {
        configArray: [],
        loading: true,
    },
    sngConfigs: {
        configArray: [],
        loading: true,
    },
    mttConfigs: {
        configArray: [],
        loading: true,
    }
};

export interface AllConfigTypes extends CommonConfigProps {
    waitinglist?: Array<string>;
    blinds?: string;
    minBuyIn?: number;
    maxBuyIn?: number;
    gpsRestriction?: boolean;
    blindsTime?: number;
    startingDate?: Seconds;
    isThereEmptySeat?: boolean;
    isAcceptedAtTable?: boolean;
    isRequestedAlready?: boolean;
}

export interface IGameConfig<T> {
    configArray: Array<T>;
    loading: boolean;
}
